function unhide(node) {
	node.removeAttribute('hidden');
}

function remove(node) {
	node.parentNode.removeChild(node);
}

function onViewAll(e) {
	if ( e && e.preventDefault ) {
		e.preventDefault();
	}

	const terms = this.closest('.terms');

	if ( ! terms ) {
		return;
	}

	const parent = this.closest('.terms__more');
	const hidden = terms.querySelectorAll('.terms__term[hidden]');

	if ( parent ) {
		remove(parent);
	} else {
		remove(this);
	}

	hidden.forEach( unhide );
}

function terms( node ) {
	const more = node.querySelector( '.terms__more-button' );

	if ( more ) {
		more.addEventListener('click', onViewAll);
	}
}

export default document.querySelectorAll('.terms').forEach( terms );
